import { trimTrailingSlashes } from '@integrations-gateway/shared-url';
import axios from 'axios';

const rawBaseURL = process.env.VITE_BFF_API_URL;
if (!rawBaseURL) {
  throw new Error('VITE_BFF_API_URL is not set');
}
const normalizedBaseURL = trimTrailingSlashes(rawBaseURL);

const baseURL = /\/api\/v\d+$/i.test(normalizedBaseURL)
  ? normalizedBaseURL
  : /\/api$/i.test(normalizedBaseURL)
    ? `${normalizedBaseURL}/v1`
    : `${normalizedBaseURL}/api/v1`;

export const apiClient = axios.create({
  baseURL,
});
